export const body = {
    create: "create",
    folder: "folder",
    message: "message",
};
